import { combineReducers } from "redux";
import options from "./Options/Reducers/optionsReducers";
import equity from "./Equity/Reducers/equityReducer";
import checkHolidayReducer from "./Common/Reducers/CheckHoliday";
import understandingSection from "./Common/Reducers/UnderstandSection";
import futures from "./Futures/Reducers/futuresMainReducer";
import NewOnEdel from "./Common/Reducers/NewOnEdelReducer";
import primaryMarketIPO from "./PrimaryMarket/IPO/Reducers/PrimaryMarketIPOReducer";
import primaryMarketNFO from "./PrimaryMarket/NFO/Reducers/PrimaryMarketNFOReducer";
import primaryMarketNCDIPO from "./PrimaryMarket/NCD_IPO/Reducers/PrimaryMarketNCDIPOReducer";
import MutualFunds from "./MutualFunds/Reducers/MutualFunds";
import etf from "./Etf/Reducers/ETFReducer";
export default combineReducers({
    equity,
    options,
    futures,
    checkHolidayReducer,
    understandingSection,
    NewOnEdel,
    primaryMarketIPO,
    MutualFunds,
    primaryMarketNFO,
    primaryMarketNCDIPO,
    etf,
});
